import { Route, Routes, Navigate, useNavigate} from 'react-router-dom';
import Layout from './components/layout/Layout';
import MainPage from './pages/MainPage';
import NotFoundPage from './pages/NotFoundPage';
import BatterPage from './pages/BatterPage';
import PitcherPage from './pages/PitcherPage';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import AuthPage from './pages/AuthPage';

function App() {
    return (
        <Layout>
            <Routes>
                {
                    <Route element={<AuthPage/>} >
                        <Route path="/batter/:playerId" element={<BatterPage/>}></Route>
                        <Route path="/pitcher/:playerId" element={<PitcherPage/>}></Route>
                        <Route path="/" element={<MainPage/>}></Route>
                        <Route path="/*" element={<NotFoundPage/>}></Route>
                    </Route>
                }
            </Routes>
        </Layout>
    )
}

export default App;
